import { GameSpeedSettings } from '@colonist/types';
import { TimeUtils } from '@colonist/utils';
export const RED_TIMER_AND_TICKING_SOUND_THRESHOLD = 5;
export class GameTimerUtils {
    static shouldDisable10SecondRuleFor(gameSpeed) {
        switch(gameSpeed){
            case GameSpeedSettings.Base15s:
            case GameSpeedSettings.Base30s:
            case GameSpeedSettings.Base60s:
            case GameSpeedSettings.Rush5s:
            case GameSpeedSettings.Rush8s:
            case GameSpeedSettings.Rush10s:
            case GameSpeedSettings.Rush15s:
            case GameSpeedSettings.Rush20s:
                return true;
            case GameSpeedSettings.Base120s:
            case GameSpeedSettings.Base240s:
            case GameSpeedSettings.Base12000s:
                return false;
        }
    }
    static getDefaultTradeAutoRejectionTimeByGameSpeed(gameSpeed) {
        switch(gameSpeed){
            case GameSpeedSettings.Base15s:
                return 6 * TimeUtils.MILLISECONDS;
            case GameSpeedSettings.Base30s:
                return 8 * TimeUtils.MILLISECONDS;
            case GameSpeedSettings.Base60s:
                return 10 * TimeUtils.MILLISECONDS;
            case GameSpeedSettings.Base120s:
                return 13 * TimeUtils.MILLISECONDS;
            case GameSpeedSettings.Base240s:
                return 15 * TimeUtils.MILLISECONDS;
            case GameSpeedSettings.Base12000s:
                return 20 * TimeUtils.MILLISECONDS;
            case GameSpeedSettings.Rush5s:
                return 4 * TimeUtils.MILLISECONDS;
            case GameSpeedSettings.Rush8s:
                return 6 * TimeUtils.MILLISECONDS;
            case GameSpeedSettings.Rush10s:
                return 8 * TimeUtils.MILLISECONDS;
            case GameSpeedSettings.Rush15s:
                return 12 * TimeUtils.MILLISECONDS;
            case GameSpeedSettings.Rush20s:
                return 15 * TimeUtils.MILLISECONDS;
        }
    }
}
